export default {
  text: '#f1f1f1',
  primary: '#c19928',
  secondary: '#c19928',
  background: '#1b1b1b',
  backgroundSecondary: '#fff',
  light: '#FFF',
  dark: '#202020'
}
